"use strict";

exports.__esModule = true;
exports.getUnitDefinition = getUnitDefinition;
var _unitDefinitions = require("./unitDefinitions");
exports.unitDefinitions = _unitDefinitions.unitDefinitions;
var _Utils = require("../../Utils");
/**
 * Get the definition for the units with the given name.
 */
function getUnitDefinition(name) {
  for (var i = 0; i < _unitDefinitions.unitDefinitions.length; i++) {
    var definition = _unitDefinitions.unitDefinitions[i];
    if (definition.name === name) {
      return definition;
    }
  }
  return {
    name: name,
    type: "mixed",
    label: (0, _Utils.humanizeString)(name),
    symbol: "",
    description: "Unsupported units (" + name + ")"
  };
}